/* eslint-disable react/prop-types */

import { Timeline } from "../ui/timeline";

export function VcBiography({ vcData }) {
  return (
    <div className="w-full">
      <Timeline
        data={vcData?.vc?.academics}
        title={vcData?.vc?.title}
        subtitle={vcData?.vc?.description}
      />
    </div>
  );
}
